import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HashLoader } from 'react-spinners'

function Notfound404() {
    const [isLoading, setLoading] = useState(false)
    useEffect(() => {
        setTimeout(() => {
            setLoading(true)
        }, 2500)
    }, [])

    return (
        <>
            {
                isLoading ?
                    <main className="h-screen w-full flex flex-col justify-center items-center bg-none">
                        <h1 className="text-9xl font-extrabold text-[#FF9768] tracking-widest">404</h1>
                        <div className="text-4xl px-2 font-bold rounded absolutes text-[#FF9768]">
                            PAGE NOT FOUND
                        </div>

                    </main> : <div className="h-screen w-full flex justify-center items-center"><HashLoader loading={true} color="#FF9768" /></div>
            }
        </>
    )
}

export default Notfound404